import type { ChangeLogTag } from './interfaces';

/**
 * The badge of a change's origin. The backend names the origin and labels it in the user's language,
 * so the key selects the colour and the label is shown as it came, or the bare key when it has none.
 */
export const toOriginTag = (origin: { key?: string | null; value?: string | null } | null | undefined): ChangeLogTag => ({
  key: origin?.key ?? '',
  value: origin?.value || origin?.key || '',
});
